<script lang="ts">
	//Design system components
	import { Container } from '@Shelly/shelly-design-system';
	//Services
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Comoponents
	import RollerSliderWrapper from './RollerSliderWrapper.svelte';
	import ActionSelectionWrapper from './ActionSelectionWrapper.svelte';

	const scheduleStore: SvelteStore<any> = getContext('schedule');

	let selection =
		$scheduleStore._options[$scheduleStore.options.indexOf($scheduleStore.rollerState)] ||
		$scheduleStore._options[2] ||
		$scheduleStore._options[0]; //_options[2] is position

	const dispatch = createEventDispatcher();
	$: disabled = selection !== $scheduleStore._options[2];
	const changeAction = (e) => {
		selection =
			$scheduleStore._options[$scheduleStore.options.indexOf(e.detail.selection)] ||
			$scheduleStore._options[2];

		if (selection !== $scheduleStore._options[2]) {
			dispatch('update', {
				rollerState: $scheduleStore.options[$scheduleStore.options.indexOf(e.detail.selection)],
				rollerHeight: '101',
			});
		} else {
			dispatch('update', {
				rollerHeight: $scheduleStore.rollerHeight !== '101' ? $scheduleStore.rollerHeight : 0,
			});
		}
	};
	const changeHeight = (e) => {
		selection = $scheduleStore._options[2];
		dispatch('update', e.detail);
	};
	let calibrated = $scheduleStore.calibrated;
	const icons = ['fa-solid fa-blinds-raised', 'fa-solid fa-blinds', 'fa-solid fa-location-pin'];
</script>

<ActionSelectionWrapper {icons} {selection} on:update={changeAction} />

{#if calibrated}
	<Container class="mt-s">
		<RollerSliderWrapper {disabled} on:update={changeHeight} slot="bottom" />
	</Container>
{/if}
